export default __webpack_public_path__ + "static/media/nft.c3117a57.png";